import React from "react";
import {
  Navigation,
  Page,
  Storage,
  TaskMultiChoice,
  TaskMultiSelect,
  TaskMultiChoiceButton,
  Image
} from "@bittnerdevelopmentgroup/interactive";

import panel1 from "./assets/PrinEco4_NonbindingMinimumWage_p1.jpg"
import panel2 from "./assets/Int_PrinEco5_6a-2_Custom.jpg"
import panel3 from "./assets/PrinEco4_NonbindingMinimumWage_p3.jpg"
import panel4 from "./assets/Int_PrinEco5_6a-4_Custom.jpg"

class Ch6InterestOnReserves extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div className="nonbindingMinimumWage">
        <div className="sr-only" aria-hidden="true">
          {[panel1, panel2, panel3, panel4].map(src => <img alt="" src={src} />)}
        </div>
        <Navigation interactiveId="chapter-6">
          <Page>
            <p>
              Imagine you are in the state legislature and are hearing complaints
              from your constituents that the price of gasoline is too high. Your
              constituents want you to put a maximum price, a <b>price ceiling</b>,
              on the price of gasoline. The equilibrium price of unleaded gasoline in your
              state, including taxes, is $4 per gallon.
            </p>
            <p align="center">
              <Image
                src={panel1}
                alt="Six peoples' hands holding up protest signs that read &quot;Price of gas too high!,&quot; &quot;Affordable gasoline now,&quot; &quot;Voters for Affordable Fuel,&quot; &quot;Do something!,&quot; &quot;Stop pumping up the pump,&quot; and &quot;No more expensive fuel.&quot;"
                width="80%"
                photoCredit={"Vektor illustration/Shutterstock"}
              />
            </p>
          </Page>
          <Page>
            <p>
              Suppose you and your fellow state legislators vote to approve a <b>price
                ceiling</b> of $3 per gallon on unleaded gasoline purchased at the pump.
              This includes any state, local, and other taxes.
            </p>
            <p align='center'>
              <Image
                src={panel2}
                alt="A photo of a car being tanked up at a gas station."
                photoCredit={"Shutterstock / jittawit21"}
                width="70%"
              />
            </p>
            <TaskMultiSelect
              key="nmwpanel2"
              state={Storage()}
              prompt={
                <>
                  <b>
                    Which of the following pump prices for unleaded gasoline will be illegal with the new maximum price of gasoline of $3 per gallon?&nbsp;
                  </b>
                  <em>Select all that apply.</em>
                </>
              }
              data={[
                {
                  label: <>
                    $4.00 per gallon
                  </>,
                  correct: true,
                },
                {
                  label: <>
                    $4.50 per gallon
                  </>,
                  correct: true,
                },
                {
                  label: <>
                    $3.50 per gallon
                  </>,
                  correct: true,
                },
                {
                  label: <>
                    $2.75 per gallon
                  </>,
                  correct: false,
                },
              ]}
              correctFeedback={
                <>
                  <p>
                    Yes! When the price is at or below the price ceiling, the maximum price, it is not impacted by the price ceiling legislation.
                  </p>
                  <p>
                    A price ceiling that forces the price to change is called a <b>binding</b> price ceiling. A price ceiling that has no effect is called <b>nonbinding</b>.
                  </p>
                </>
              }
              incorrectFeedback="In this case, if a price is above the price ceiling (>$3), it will have to change. If a price is below the price ceiling (≤$3), it will not have to change. Be sure to double check that you selected all of the correct answers."
            />
          </Page>
          <Page>
            <p>
              In your state, a one-pound bag of locally roasted coffee beans costs $10. Recently, however, some
              major coffee distributors started selling lower-quality bags of beans in your state for $8 per pound,
              driving down the cost of coffee and threatening the livelihood of local coffee roasters.
            </p>
            <p align="center">
              <Image
                src={panel3}
                alt="A photo of a latte in a paper cup."
                longAlt={"A photo of a latte in a paper cup. A fancy design has been created in the froth floating on top."}
                photoCredit={"Ryan McGinnis/ Alamy Stock Photo"}
                width="60%"
              />
            </p>
            <TaskMultiChoice
              prompt={
                <>
                  <b>
                    How do you think this price floor affects the quantity of locally roasted beans that are sold?
                  </b>
                </>
              }
              key="nmwpanel3"
              state={Storage()}
              choices={[
                <>
                  Sales of local beans go down.
                </>,
                <>
                  Sales of local beans go up.
                </>,
                <>
                  Sales of local beans stay the same.
                </>,
              ]}
              correct={1}
              feedback={[
                <>
                  Not quite. If you could get local, high-quality beans for the same price as lower-quality, big-brand beans, which would you choose?
                </>,
                <>
                  Because the local, high-quality beans are now the same price as the lower-quality, big-brand beans, many consumers will opt for the local option, increasing sales.
                </>,
                <>
                  Not quite. If you could get local, high-quality beans for the same price as lower-quality, big-brand beans, which would you choose?
                </>,
              ]}
            />
          </Page>
          <Page>
            <p>
              Just like with price ceilings, a price floor that forces the price to
              change is called a <b>binding</b> price floor. A price floor that has no effect
              is called <b>nonbinding</b>.
            </p>
            <p align="center">
              <Image
                src={panel4}
                alt="A bowl full of roasted coffee beans."
                longAlt={"A bowl full of roasted coffee beans. A spoon containing a few more beans lies to one side."}
                photoCredit={"Shutterstock / Mulad Images"}
                width="70%"
              />
            </p>
            <TaskMultiChoiceButton
              prompt={<b>Is the $10-per-pound price floor on coffee beans binding or nonbinding?</b>}
              key="ffnpanel2"
              state={Storage()}
              data={[{
                value: <span>
                  binding
                </span>,
                correct: true,
                feedback: <div>
                  This price floor has an effect on nonlocal coffee firms, meaning that it is <b>binding</b>.
                </div>
              }, {
                value: <span>
                  nonbinding
                </span>,
                correct: false,
                feedback: <div>
                  Remember that the nonlocal firms are forced to change their prices. That means that this price floor is <b>binding</b>.
                </div>
              }]}
            />
          </Page>
        </Navigation>
      </div>
    )
  }
}

export default Ch6InterestOnReserves
